import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-account',
  templateUrl: './admin-account.component.html',
  styleUrls: ['./admin-account.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class AdminAccountComponent {
  constructor() {
    console.log('AdminAccountComponent loaded');
  }
}
